module.exports = __webpack_public_path__ + "img/main-mob.28308990.svg";